/**
 * NotificationSystem Entity - Notification/Alert management
 * Tracks notifications sent during mission execution
 */
class NotificationSystem {
    constructor() {
        this.notifications = [];
    }

    /**
     * Send a notification
     * @param {string} message - Notification message
     */
    notify(message) {
        this.notifications.push(message);
    }

    /**
     * Get all notifications
     * @returns {Array}
     */
    getNotifications() {
        return [...this.notifications];
    }

    /**
     * Get current state
     * @returns {Array}
     */
    getState() {
        return this.getNotifications();
    }

    /**
     * Clear all notifications
     */
    reset() {
        this.notifications = [];
    }
}

// Universal export (Node.js + React)
if (typeof module !== 'undefined' && module.exports) {
    module.exports = NotificationSystem;
}
export default NotificationSystem;
